"use strict";

/* -------------------------------------------------------------------------

	PUNITED.utils

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.utils) PUNITED.utils = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.utils;
  /* -----------------------------------------------------
  	Calculate scrollbar width
  ----------------------------------------------------- */

  ns.getScrollbarWidth = function () {
    return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
  };
  /* -----------------------------------------------------
  	Calculate and set scrollbar width property
  ----------------------------------------------------- */


  ns.setScrollbarWidth = function () {
    var width = ns.getScrollbarWidth();
    var prop = "".concat(width, "px");
    document.body.style.setProperty('--scrollbar--width', prop);
    return width;
  };
  /* -----------------------------------------------------
  	Calculate scrollbar width of an overflow element
  ----------------------------------------------------- */


  ns.getScrollerScrollbarWidth = function (scroller) {
    return Math.max(0, scroller.offsetWidth - scroller.clientWidth);
  };
  /**
   * Disable or enable scroll on the page
   *
   * @param force undefined|boolean	The same as `force` param of classList.toggle().
   * */


  ns.toggleNoScroll = function (force) {
    document.body.classList.toggle('no_scroll', force);
  };
  /* -----------------------------------------------------
  	Control a modal
  		PUNITED.utils.modal('#modal_id', '#btn_id');
  ----------------------------------------------------- */


  ns.modal = function (modalSelector, triggerSelectors) {
    var triggers = document.querySelectorAll(triggerSelectors);
    var modal = document.querySelector(modalSelector);
    var inner = modal.querySelector('.modal__inner');
    var content = modal.querySelector('.modal__content');
    var innerTriggerClassNames = ['modal__inner', 'modal__close'];
    var isAnimating = false;
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', handleTriggerClick);
    });
    modal.addEventListener('keydown', handleKeydown);
    modal.addEventListener('click', handleInnerTriggerClick);

    function handleTriggerClick(e) {
      handleToggle();
    }

    function handleKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        handleToggle(false);
      }
    }

    function handleInnerTriggerClick(e) {
      var close = innerTriggerClassNames.some(function (className) {
        return e.target.classList.contains(className);
      });

      if (!close) {
        return;
      }

      handleToggle(!close);
    }

    function handleToggle(force) {
      if (isAnimating) {
        return;
      }

      isAnimating = true;
      var open = !modal.classList.contains('--open') || force;

      if (open) {
        modal.showModal();
        inner.scrollTop = 0;
        content.scrollTop = 0;
        var w = Math.abs(ns.setScrollbarWidth() - ns.getScrollerScrollbarWidth(inner));
        modal.style.setProperty('--modal--scrollbar--width', "".concat(w, "px"));
        waitForAnimation(function () {
          modal.classList.add('--open');
          ns.toggleNoScroll(open);
          isAnimating = false;
        });
      } else {
        modal.classList.remove('--open');
        waitForAnimation(function () {
          modal.close();
          ns.toggleNoScroll(open);
          isAnimating = false;
        });
      }
    }

    function waitForAnimation(callback) {
      Promise.all(modal.getAnimations({
        subtree: true
      }).map(function (animation) {
        return animation.finished;
      })).then(function () {
        return callback();
      });
    }
  };
  /* -----------------------------------------------------
  	Image slider
  ----------------------------------------------------- */


  ns.imgSlider = function () {
    var containers = document.querySelectorAll('.img_slider');
    containers.forEach(function (container) {
      var slider = container.querySelector('.splide');
      var nav = slider.querySelector('.img_slider__nav');
      var slides = slider.querySelectorAll('.splide__slide');
      var single = slides.length === 1;
      nav.style.display = single ? 'none' : '';
      var slideSpeed = 2000;
      var slideDelay = 3000;
      var splide = new Splide(slider, {
        type: 'fade',
        rewind: true,
        speed: slideSpeed,
        easing: 'ease',
        interval: slideSpeed + slideDelay,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false
      });
      splide.mount();
    });
  };

  ns.pageMenu = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.page_menu__link';
    var mq = PUNITED.common.mediaQuery;
    var images = Array.from(document.querySelectorAll('.wp-block-image:not(.sp_none) img[loading="lazy"]'));
    var completeImages = images.map(function (image) {
      return image.complete;
    });

    if (mq.matches) {
      images.forEach(function (image) {
        return image.loading = 'eager';
      });
    }

    var currentTarget;
    var links = document.querySelectorAll(selector);
    links.forEach(function (link) {
      var href = link.getAttribute('href');

      if (!href.startsWith('#')) {
        return;
      }

      var id = href.replace('#', '');
      var target = document.getElementById(id);

      if (!target) {
        return;
      }

      init(link, href, target);
    });
    var paramKey = 'anc';
    var params = new URLSearchParams(window.location.search);

    if (params.has(paramKey)) {
      currentTarget = document.getElementById(params.get(paramKey));

      if (!currentTarget) {
        return;
      }

      handleCurrentTarget();
    }

    function init(link, href, target) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        currentTarget = target;
        handleCurrentTarget();
      });
    }

    function handleCurrentTarget() {
      if (!mq.matches || isEveryImageLoaded()) {
        scrollToCurrent();
        return;
      }

      preloadImages();
    }

    function scrollToCurrent() {
      var _currentTarget;

      (_currentTarget = currentTarget) === null || _currentTarget === void 0 ? void 0 : _currentTarget.scrollIntoView({
        behavior: 'smooth'
      });
      currentTarget = null;
    }

    function preloadImages() {
      images.forEach(function (image, i) {
        if (image.complete) {
          completeImages[i] = image.complete;
          return;
        }

        image.addEventListener('load', function () {
          completeImages[i] = image.complete;

          if (isEveryImageLoaded()) {
            scrollToCurrent();
          }
        });
      });

      if (isEveryImageLoaded()) {
        scrollToCurrent();
      }
    }

    function isEveryImageLoaded() {
      return completeImages.every(function (complete) {
        return complete;
      });
    }
  };
})();